var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCartMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.69 353.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70777e;}.cls-2{fill:#4d4d53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,148.18v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,148.18v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,144.44v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,148.18v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,140.71l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,145.32v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,148.18v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,148.72v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,146.98v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,144.44v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,143.63l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,142.06l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,284.9v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,284.9v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,281.16v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,284.9v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,277.44l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,282.05v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,284.9v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,285.44v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,283.7v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,281.16v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,280.36l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,278.78l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,216.54v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,216.54v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,212.8v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,216.54v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,209.08l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,213.69v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,216.54v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,217.08v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,215.34v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,212.8v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,212l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,210.42l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,353.26v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,353.26v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,349.52v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,353.26v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,345.8l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,350.41v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,353.26v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,353.8v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,352.06v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,349.52v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,348.72l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,347.14l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,182.36v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,182.36v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,178.62v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,182.36v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,174.9l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,179.5v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,182.36v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,182.9v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,181.16v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,178.62v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,177.82l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,176.24l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,319.08v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,319.08v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,315.34v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,319.08v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,311.62l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,316.23v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,319.08v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,319.62v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,317.88v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,315.34v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,314.54l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,312.96l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.06,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.8,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.31,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.23,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.23,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.41,250.72v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.48,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.19,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.67,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m58.23,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.19,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m69.93,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.44,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.36,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.36,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.13,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.54,250.72v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.61,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.32,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m113.71,246.98v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m121.35,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.32,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.06,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m138.57,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.49,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.26,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m159.67,250.72v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m166.74,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m172.45,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m177.93,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.48,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.45,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m196.19,243.26l-1.06-1.2.02-.03h1.44l.77,1.22h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.7,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.62,247.87v-1.33h2.14v1.33h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.62,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.39,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1-.13.34-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.8,250.72v-.83h4.22v.83h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m229.86,251.26v-.21c.24-.24.42-.49.54-.74.12-.25.18-.51.18-.79h-.76v-1.72h1.66v1.44c0,.39-.06.76-.19,1.1s-.32.65-.57.92h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.58,249.52v-1.52h1.62v1.52h-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m239.97,246.98v-1.08h4.32v1.08h-4.32Zm0,1.86v-1.08h4.32v1.08h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.61,246.18l-.4-1.21v-1.24h1.31v1.24l-.4,1.21h-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.57,244.6l-1.05-1.48.02-.03h1.39l.77,1.5h-1.12Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.09,6.78v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m104.64,5.66v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.74,4.12v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.85,2.55l-.37-1.12V.27h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.2,2.55l-.37-1.12V.27h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,7.22V0h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.89,2.55l-.37-1.12V.27h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.23,2.55l-.37-1.12V.27h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m141.81,4.12v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m147.4,5.66v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.54,6.78v-.77h3.93v.77h-3.93Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.26,15.09v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.36,13.55v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.47,11.98l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,16.66v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.81,10.51l-.98-1.38.02-.02h1.3l.72,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.19,13.55v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.78,15.09v-1.41h1.51v1.41h-1.51Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.57,24.52v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.44,21.41l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.34,25.87l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,26.09v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.18,25.87l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.85,19.94l-.98-1.38.02-.02h1.3l.72,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.47,24.52v-1.41h1.51v1.41h-1.51Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.88,33.96v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.75,30.84l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.68,35.3l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,35.52v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.83,35.3l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.54,29.37l-.98-1.38.02-.02h1.3l.72,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m190.16,33.96v-1.41h1.51v1.41h-1.51Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.96,44.73l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.03,44.73l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,44.95v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.49,44.73l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m188.56,44.73l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.95,48.24l-.98-1.38.02-.02h1.3l.72,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.65,54.17l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.37,54.17l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,54.39v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.14,54.17l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.87,54.17l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.34,49.71l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.64,57.67l-.98-1.38.02-.02h1.3l.71,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.34,63.6l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.72,63.6l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,63.82v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.8,63.6l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.18,63.6l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.65,59.14l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.33,67.1l-.98-1.38.02-.02h1.3l.71,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.03,73.03l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.06,73.03l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,73.25v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.45,73.03l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.49,73.03l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.96,68.57l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.05,82.23v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.61,81.12v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.71,79.58v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.02,76.54l-.98-1.38.02-.02h1.3l.71,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.72,82.46l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.41,82.46l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,82.68v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.11,82.46l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.8,82.46l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.27,78.01l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.85,79.58v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.44,81.12v-1.41h1.51v1.41h-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.57,82.23v-.77h3.93v.77h-3.93Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.84,91.8c-.39.05-.71.05-.97,0-.26-.06-.45-.16-.58-.31-.13-.15-.19-.34-.19-.57v-1.7c0-.16-.06-.27-.18-.33s-.26-.1-.42-.1v-.62c.14,0,.27-.04.4-.11.13-.07.2-.18.2-.34v-1.68c0-.24.07-.43.2-.58.13-.15.33-.25.59-.3.26-.05.58-.05.96,0v.53c-.07,0-.15,0-.24.02-.09.01-.17.04-.24.09s-.11.12-.12.22l-.08,1.62c-.01.26-.08.46-.2.6-.13.14-.32.21-.59.21v.07c.27,0,.46.07.59.21.13.14.19.34.2.6l.08,1.61c.01.1.05.17.11.22s.14.08.24.09c.09.01.17.02.25.02v.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.05,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.4,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.74,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.09,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.43,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m110.71,85.97l-.98-1.38.02-.02h1.3l.71,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.41,91.89l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.75,91.89l-3.68-6.74h1.03l3.69,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.31,92.11v-7.22h.94v7.22h-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.76,91.89l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.11,91.89l3.69-6.74h1.03l-3.68,6.74h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m142.58,87.44l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m146.19,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m151.54,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.88,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m162.23,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.57,91.67v-.77h3.93v.77h-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173.71,85.16c.39-.05.72-.05.98,0,.26.06.45.16.58.3.13.15.19.34.19.57v1.7c0,.16.06.27.18.33.12.07.26.1.42.1v.62c-.14,0-.27.04-.4.11s-.2.18-.2.34v1.68c0,.24-.07.43-.2.58s-.33.25-.59.3c-.26.05-.58.05-.96,0v-.53c.07,0,.15,0,.24-.02.09-.01.17-.04.24-.09.07-.05.11-.12.11-.21l.08-1.62c.01-.26.08-.46.2-.6.13-.14.32-.21.59-.21v-.07c-.27,0-.46-.07-.59-.21-.13-.14-.19-.34-.2-.6l-.08-1.61c0-.1-.04-.17-.11-.22s-.15-.08-.24-.09c-.09-.01-.17-.02-.25-.02v-.53Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.4,95.4l-.98-1.38.02-.02h1.3l.71,1.4h-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m125.78,98.44v-1.24h2v1.24h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.89,96.87l-.37-1.12v-1.16h1.22v1.16l-.37,1.12h-.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartMobile);
export default __webpack_public_path__ + "static/media/empty-cart-mobile.9ab04770790d381b1c3108d4b3a079b6.svg";
export { ForwardRef as ReactComponent };